var React = require('react');

function HealthyDelawareIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0v100h110V0zm84.49 84.36c-6.2-.12-12.42-.27-18.63-.37-1 0-1.18-.47-1.18-1.31q-.57-10.5-1.2-21c-.22-3.75-.45-7.49-.68-11.24H44.69v31.63h5.74v1.84H20v-1.84h5.73V17.84H20V16h30.42v1.84h-5.73v30.08h17.94l-1.36-22.06v-1.57c-.15-3.51 1.77-5.93 4.6-7.51a8.67 8.67 0 0 1 9.38.55l.12.12C74.58 18.8 74 20 73.28 21a16.1 16.1 0 0 1-1.87 2q-1.71 1.62-3.25 3.41c-.24.3.12 1.37.52 1.8a3.24 3.24 0 0 1 .51 4.24 2.66 2.66 0 0 0 0 2.24c1 1.84 2.26 3.56 3.45 5.31a3.12 3.12 0 0 0 .76.82 6.07 6.07 0 0 1 2.47 4.66c.21 2.55.08 5.12.21 7.68a2.51 2.51 0 0 0 .81 1.66 7.08 7.08 0 0 1 2.84 5.67 2.85 2.85 0 0 0 .54 1.51c1.21 1.49 2.49 3 3.77 4.49a3.44 3.44 0 0 0 4.38 1c.52 5.59 1 11.11 1.57 16.87z"}));
}

HealthyDelawareIcon.defaultProps = {"viewBox":"0 0 110 100","fill":"currentColor"};

module.exports = HealthyDelawareIcon;

HealthyDelawareIcon.default = HealthyDelawareIcon;
